import { Sorting, SortingOrder } from "../models";
import { SearchResults } from "../models/search-result";
import { Filters } from "../models/sorting";
import { BaseClient } from "./baseClient";

export interface ISearchApi {
  searchOrgDocuments(
    page: number,
    sorteer: Sorting,
    filters?: Filters,
    order?: SortingOrder,
    search?: string
  ): Promise<SearchResults>;
}

export const SearchEndpoint = (): string =>
  (process.env.REACT_APP_OAS_V2 === "true" && process.env.REACT_APP_ZOEKEN_API_ENDPOINT_V2
    ? process.env.REACT_APP_ZOEKEN_API_ENDPOINT_V2
    : process.env.REACT_APP_ZOEKEN_API_ENDPOINT) as string;

const searchHeaders = (): Headers =>
  new Headers({
    "Content-type": "application/json",
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  });

export const SearchParams = (
  from: number,
  sorteer: Sorting,
  filters: Filters,
  order?: SortingOrder,
  search?: string
): string =>
  `start=${from}&sorteer=${sorteer}&order=${order}${filters ? `&filters=${filters}` : ""}${search ? `&q=${search}` : ""}`;

export class SearchApi extends BaseClient implements ISearchApi {
  constructor() {
    super(searchHeaders(), SearchEndpoint());
  }

  searchOrgDocuments = async (
    from: number,
    sorteer: Sorting,
    filters: Filters,
    order?: SortingOrder,
    search?: string
  ) => {
    const { json } = await this.api<SearchResults>(
      "_zoek",
      undefined,
      "GET",
      undefined,
      SearchParams(from, sorteer, filters, order, search)
    );
    return json as SearchResults;
  };
}
